import { Trans } from 'react-i18next'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useBuilderActionContextV2 } from '@/context/__project__/BuilderActionContextV2'
import { useCompBackgroundColor, useCompContext } from '@/context/__project__/CompContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { useCheckVisibilityV2 } from '@/hooks/__project__/useCheckVisibilityV2'
import { ComponentSettingKey } from '@/shared/builder'

import { CompListWrapperCore } from '../core/list/wrapper'
import { CompList } from './CompList'

/**
 * @todo display list skeleton
 */
function CompListWrapper() {
  // infos
  const compContext = useCompContext()
  const { currentParentBg } = useCompBackgroundColor()
  const { activeLayer } = useActiveLayerContext()
  const actionContext = useBuilderActionContextV2()
  const { menus, listChecked, setListChecked } = useAppBuilderContext()
  const infosProps = { ...compContext, activeLayer, currentParentBg }

  // brandkit
  const [colorScheme] = useBuilderColorSchemeV2()
  const brandkitProps = { mode: colorScheme.current }

  // trailing elements configuration
  const { checkVisibility } = useCheckVisibilityV2()
  const trailingMenuId = compContext.settings[ComponentSettingKey.ListDataTrailingMenu] as string
  const trailingMenu = menus.find((m) => m.id === trailingMenuId)
  const trailingMenuVisible = checkVisibility({
    visibility: trailingMenu?.visibility,
    layerTableId: compContext.detailTableId,
    layerRowIndex: compContext.detailRowIndex,
  })

  // tableData
  const { dbClient, language, userSpecific, tablesMap } = useDbClientContext()
  const tableId = compContext.settings?.[ComponentSettingKey.ListDataSource]
  const table = tableId ? tablesMap.get(tableId as string) : undefined

  // todo: error state
  if (!table || !dbClient) {
    return (
      <div className='flex justify-center items-center py-8'>
        <Trans>COMP_TABLE_NOT_FOUND</Trans>
      </div>
    )
  }

  return (
    <CompListWrapperCore
      infos={infosProps}
      brandkit={brandkitProps}
      tableData={{ dbTable: table, dbClient, tableId, language, userSpecific }}
    >
      {(listProps) => (
        <CompList
          {...listProps}
          component={compContext.component}
          action={actionContext}
          listChecked={listChecked}
          setListChecked={setListChecked}
          trailingMenuVisible={trailingMenuVisible}
          trailingMenuId={trailingMenuId}
        />
      )}
    </CompListWrapperCore>
  )
}

export default CompListWrapper
